import { LinkIcon } from "@chakra-ui/icons";
import { Button, Flex, Text } from "@chakra-ui/react";
import apiDigitacao from "api/api-digitacao";
import { phoneSeparate } from "components/atendimentos-components/pagina-atendimento/pagined-form/parts/margens/simulacao-fields/utils";
import { CustomModal } from "components/custom-modal";
import { DropdownField } from "components/dropdown-field";
import { InputField } from "components/input-field";
import { Toast } from "components/toast";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useAttendanceContext } from "contexts/attendance-context";
import { useFormFields } from "hooks/use-form-fields";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useState } from "react";

interface ModalGerarLinkCltParams {
  onSendLinkOrder: (banco: string) => void;
}

interface POSTGerarLinkCltProps {
  banco: string;
  cpf: string;
  name?: string;
  phoneDDD1?: string;
  phoneNumber1?: string;
}

const eventName = "openModalGerarLinkClt";

export function ModalGerarLinkClt() {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState<string>();
  const { isOpen, onClose, params } = useModalControls<ModalGerarLinkCltParams>(
    eventName,
    {
      onClose: () => {
        setSelectedBank(undefined);
      },
    }
  );
  const { bancosClt } = params as { bancosClt: { name: string; value: string }[] };
  const { formControl, dispatch } = useAttendanceContext();
  const { user } = useApplicationContext();
  const attendance = formControl.values;
  const [cltFields, cltErrors, onChangeField] = useFormFields<POSTGerarLinkCltProps>();

  const postLinkOrder = async () => {
    if (!attendance.cpf?.trim()) {
      Toast({
        title: "Atendimento sem CPF",
        description: "Preencha um cpf para o atendimento",
      });
      dispatch({
        type: "setInvalidField",
        payload: { fieldName: "cpf", action: "append" },
      });
      return;
    }
    cltFields.cpf = attendance.cpf!;
    setIsLoading(true);
    try {
      const { data } = await apiDigitacao.post(
        `/api/gerar-autorizacao/${attendance.id}/link/${user.userData.customerId}`,
        cltFields
      );
      params.onSendLinkOrder?.(selectedBank!);
      onClose();
    } catch (e) {
      Toast({ title: "Erro ao gerar autorização." });
    } finally {
      setIsLoading(false);
    }
  };

  const isDisabledGerarLink = cltFields.banco === "TWO_S_CONSIG" ? !cltFields.banco || !cltFields.phoneDDD1 || !cltFields.phoneNumber1 : !cltFields.banco;

  const modalFooter = (
    <>
      <Button variant="outline" onClick={onClose}>
        Cancelar
      </Button>
      <Button
        onClick={() => postLinkOrder()}
        leftIcon={<LinkIcon />}
        isDisabled={isDisabledGerarLink}
        isLoading={isLoading}
        loadingText="Gerando solicitação"
      >
        Gerar Link
      </Button>
    </>
  );

  return (
    <CustomModal
      modalTitle="Gerar Link de Autorização"
      isOpen={isOpen}
      onClose={onClose}
      modalFooter={modalFooter}
    >
      <DropdownField
        title="Selecione o Banco"
        onChange={(value) => {
          onChangeField("banco", value);
          onChangeField("phoneDDD1", undefined);
          onChangeField("phoneNumber1", undefined);
        }}
        options={bancosClt}
        value={cltFields.banco}
      />
      {cltFields.banco === "TWO_S_CONSIG" ? (
        <>
          <Flex flexDirection="column" gap="8px" my="8px">
            <Text>Nome</Text>
            <InputField
              titleProps={{ textAlign: "end", mb: "0px" }}
              onChange={(e) => {
                onChangeField("name", e.target.value);
              }}
              inputProps={{ bg: "#fff" }}
              value={cltFields["name"]}
              errorMessage={cltErrors["name"]}
            />
          </Flex>
          <Flex flexDirection="column" gap="8px" my="8px">
            <Text>Celular</Text>
            <InputField
              titleProps={{ textAlign: "end", mb: "0px" }}
              onChange={(e) => {
                onChangeField("phoneNumber1", phoneSeparate({ completedNumber: e.target.value }).number);
                onChangeField("phoneDDD1", phoneSeparate({ completedNumber: e.target.value }).ddd);
              }}
              inputProps={{ bg: "#fff" }}
              value={phoneSeparate({ dddPhone: cltFields.phoneDDD1, phone: cltFields["phoneNumber1"] }).phoneAndDDDFormatedValue}
              errorMessage={cltErrors["phoneNumber1"]}
            />
          </Flex>
        </>
      ) : null}
    </CustomModal>
  );
}

export const openModalGerarLinkClt =
  createModalTrigger<ModalGerarLinkCltParams & { bancosClt: { name: string; value: string }[] }>(eventName);
